import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowDownRightIcon } from 'lucide-react';
import { heroImage, contact } from '../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-paper pt-28 lg:pt-32" data-id="element-63" data-mp="9ip7sz70irub">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-64" data-mp="4njrqh0ak7e5">
        <div className="grid items-end gap-10 lg:grid-cols-12 lg:gap-8" data-id="element-65" data-mp="129qtzk94hnnc">
          <div className="lg:col-span-7" data-id="element-66" data-mp="xae74zi94gkr">
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.3,
            ease
          }} className="text-[11px] uppercase tracking-label text-graphite" data-id="element-67" data-mp="xbpc32nfnudg">
              Chabanière — Lyon & Monts du Lyonnais
            </motion.p>

            <motion.h1 initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.05,
            ease
          }} className="mt-6 font-display text-[clamp(2.75rem,7vw,6.5rem)] leading-[0.92] tracking-tight" data-id="element-68" data-mp="3d2torapbqmf2">
              Architecte d’intérieur,
              <br data-id="element-69" data-mp="39acuwgqk58pb" />
              <span className="text-clay" data-id="element-70" data-mp="39b4hx3639y3z">dessin BTP</span> &amp; BIM
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.12,
            ease
          }} className="mt-8 flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between" data-id="element-71" data-mp="3e8wjkowjcyld">
              <p className="max-w-md text-[15px] leading-relaxed text-graphite" data-id="element-72" data-mp="2qk3muq83ampp">
                Je dessine, documente et accompagne vos projets neufs ou de rénovation — de l’état des lieux au
                suivi de chantier. Pour les particuliers comme pour les professionnels.
              </p>
              <div className="flex items-center gap-6" data-id="element-73" data-mp="2lkike5tpnw88">
                <Link to="/contact" className="bg-ink px-7 py-4 text-[11px] uppercase tracking-label text-paper transition-colors duration-150 ease-smooth hover:bg-clay" data-id="element-74" data-mp="2ljz22o05f5to">
                  Démarrer un projet
                </Link>
                <a href="#projets" className="group inline-flex items-center gap-2 text-[11px] uppercase tracking-label text-ink" data-id="element-75" data-mp="id048r6rk6on">
                  Voir les projets
                  <ArrowDownRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5 group-hover:translate-y-0.5" data-id="element-76" data-mp="1b049mx9rqn0y" />
                </a>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5" data-id="element-77" data-mp="x1ec5gj1elc2">
            <dl className="grid grid-cols-3 gap-6 border-t border-line pt-6 lg:mb-2" data-id="element-78" data-mp="x0l4mdc97rsv">
              {[{
              k: '2014',
              v: 'Premiers dossiers'
            }, {
              k: '10 ans',
              v: 'D’expérience BIM'
            }, {
              k: '100 %',
              v: 'Sur-mesure'
            }].map(item => <div key={item.k} data-id="element-79" data-mp="1xavxukzeea7s">
                  <dt className="font-display text-2xl leading-none" data-id="element-80" data-mp="1x7hxtje7id3i">{item.k}</dt>
                  <dd className="mt-2 text-xs leading-snug text-graphite" data-id="element-81" data-mp="218toztcqb6dt">{item.v}</dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>

      <motion.figure initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      delay: 0.1,
      ease
    }} className="relative mt-12 lg:mt-16" data-id="element-82" data-mp="2b2aiew8yejgy">
        <img src={heroImage} alt="Maison contemporaine réalisée à partir des plans de DACB, façade blanche et bardage bois au crépuscule" className="h-[46vh] w-full object-cover sm:h-[62vh] lg:h-[74vh]" data-id="element-83" data-mp="2l100ap0uo3x7" />
        <figcaption className="mx-auto flex max-w-shell items-center justify-between px-6 py-4 text-[11px] uppercase tracking-label text-graphite lg:px-10" data-id="element-84" data-mp="umzkk23cggai">
          <span data-id="element-85" data-mp="znn8gewa0h0i">Maison individuelle — Monts du Lyonnais</span>
          <a href={contact.phoneHref} className="hidden transition-colors duration-150 ease-smooth hover:text-clay sm:block" data-id="element-86" data-mp="4a2ulkgef9zm">
            {contact.phone}
          </a>
        </figcaption>
      </motion.figure>
    </section>;
}